import React, {Component} from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

/**
 * Custom wrapper for IntlProvider to make it react to language switching
 */
class MyIntlProvider extends Component {
    render() {
        const {lang, messages} = this.props;

        return (
            <IntlProvider {...this.props} key="intl" locale={lang} messages={messages[lang]}>
                {this.props.children}
            </IntlProvider>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.language.lang
});

export default connect(mapStateToProps)(MyIntlProvider);



// WEBPACK FOOTER //
// ./src/config/MyIntlProvider.jsx